import dayjs from 'dayjs'

export const getDateFromIso = (strDate: string) => dayjs(strDate).utc().format('MMM DD YYYY')
